var map = {
	"./add.svg": "2930",
	"./bulletins-update.svg": "614b",
	"./bulletins.svg": "18e8",
	"./check.svg": "6583",
	"./check_circle.svg": "b216",
	"./chevron-down.svg": "57f4",
	"./claim-flag-update.svg": "e4fe",
	"./claim-flag.svg": "6b51",
	"./claim.svg": "1593",
	"./clipboard.svg": "e7af",
	"./close.svg": "369e",
	"./copy.svg": "8110",
	"./date-down.svg": "f3db",
	"./dealer.svg": "5cca",
	"./delete.svg": "91c6",
	"./download-blue.svg": "118e",
	"./download.svg": "d45c",
	"./email-dark.svg": "26f3",
	"./error.svg": "a45c",
	"./exclamation.svg": "bcc3",
	"./git-commit.svg": "1548",
	"./header-menu-button.svg": "63cf",
	"./history.svg": "cdd9",
	"./image.svg": "da92",
	"./key.svg": "5768",
	"./labor.svg": "4973",
	"./loading.svg": "7d2d",
	"./log-in.svg": "d63b",
	"./media.svg": "b342",
	"./menu.svg": "f37e",
	"./more-alt.svg": "66e1",
	"./news.svg": "9caf",
	"./notes.svg": "562b",
	"./old-claim.svg": "0e0e",
	"./order-basket-update.svg": "20fd",
	"./order-basket.svg": "5a41",
	"./print.svg": "b776",
	"./redo.svg": "360d",
	"./search.svg": "fe78",
	"./select.svg": "6319",
	"./settings.svg": "8524",
	"./sort-arrows.svg": "6e66",
	"./success.svg": "2389",
	"./tractor.svg": "5374",
	"./user.svg": "c881",
	"./website.svg": "01b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5629";